import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from '../../styles/printFont/vfs_fonts2';
import helper from "actions/helper";

//Вывести логотип влево вверху 
/*function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            let canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            let ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            let dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}*/

const Print = async (listInv) => {


    const { vfs } = pdfFonts.pdfMake;
    pdfMake.vfs = vfs;

    pdfMake.fonts = {
        Roboto: {
            normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
            bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
            italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
            bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
        },
    };

    const getRow = (i, data, isDiscount) => {
        const { title, price, count, sum, discount, sumDiscount, teeths } = data;
        const row = [
            { text: i + 1 + "", alignment: 'center' },
            { text: title },
            { text: teeths, alignment: 'center' },
            { text: count, alignment: 'center' },
            { text: price, alignment: 'center' },
        ];

        if (isDiscount) {
            row.push({ text: sum, alignment: 'center' });
            row.push({ text: discount, alignment: 'center' });
            row.push({ text: sumDiscount, alignment: 'center' });
        } else {
            row.push({ text: sum, alignment: 'center' });
        }

        return row;
    };

    const getRows = (it, isDiscount) => {
        let body = [[
            { text: "№", fillColor: '#B6DCFA', bold: true },
            { text: "Наименование позиции", alignment: 'center', fillColor: '#B6DCFA', bold: true },
            { text: "Зубы", alignment: 'center', fillColor: '#B6DCFA', bold: true },
            { text: "Кол-во", alignment: 'center', fillColor: '#B6DCFA', bold: true },
            { text: "Цена", alignment: 'center', fillColor: '#B6DCFA', bold: true },
        ]];

        if (isDiscount) {
            body[0].push({ text: "Стоимость", alignment: 'center', fillColor: '#B6DCFA', bold: true });
            body[0].push({ text: "Скидка", alignment: 'center', fillColor: '#B6DCFA', bold: true });
            body[0].push({ text: "Сумма со скидкой", alignment: 'center', fillColor: '#B6DCFA', bold: true });
        } else {
            body[0].push({ text: "Стоимость", alignment: 'center', fillColor: '#B6DCFA', bold: true });
        }

        const defaultSize = {
            pricecount: 50,
            price: 25,
            amount: 30,
            teeths: 25,
            sumDiscount: 30
        };

        it.securedInvoiceItems.sort((a, b) => a.sortIndex - b.sortIndex).forEach((inv, i) => {
            const { altCode, title, price, count, discount, teeth } = inv;
            const data = {
                title: `${altCode} ${title}`,
                teeths: helper.getTeethNames(teeth).join(", "),
                count: count + "",
                price: helper.number.toSum(price),
                sum: helper.number.toSum(price * count),
            };

            if (isDiscount) {
                data.discount = ((discount && discount.toFixed(2)) || 0) + "%";
                data.sumDiscount = `${helper.number.toSum(helper.number.percentMinus(price * count, discount))}`;
            }

            body = [...body, getRow(i, data, isDiscount)];

            if (data.price.length === 7)
                defaultSize.price = 40;
            else if (data.price.length === 8)
                defaultSize.price = 45;
            else if (data.price.length === 9)
                defaultSize.price = 50;
            else if (data.price.length > 9)
                defaultSize.price = 55;

            if (isDiscount) {
                if (data.sumDiscount.length === 7)
                    defaultSize.sumDiscount = 40;
                else if (data.sumDiscount.length === 8)
                    defaultSize.sumDiscount = 45;
                else if (data.sumDiscount.length === 8)
                    defaultSize.sumDiscount = 50;
                else if (data.sumDiscount.length > 8)
                    defaultSize.sumDiscount = 55;
            }

            if (data.teeths.length > 14)
                defaultSize.teeths = 70;
            else if (data.teeths.length > 11)
                defaultSize.teeths = 55;
            else if (data.teeths.length > 8)
                defaultSize.teeths = 50;
            else if (data.teeths.length > 6)
                defaultSize.teeths = 40;
        });

        const { pricecount, price, amount, teeths, sumDiscount } = defaultSize;

        const widths = isDiscount ? [15, '*', teeths, amount, price, pricecount, 35, sumDiscount] : [15, '*', teeths, amount, price, pricecount];

        return { widths, body };
    };

    const formPage = (it, isLast) => {
        const isDiscount = it.securedInvoiceItems.some(inv => inv.discount);
        const balance = it.clientBalance?.balance + it.clientBalance?.bonus;

        const bodyItogo = [];

        if (isLast) {
            bodyItogo.push([
                "Сумма на авансе",
                { text: helper.number.toSum(balance), bold: true },
                "",
                "",
            ]);

            if (it.debt) {
                bodyItogo.push([
                    "",
                    "",
                    "",
                    "",
                ]);
            }
        }

        const page = [
            {
                style: 'header2',
                text: [
                    { text: "Предварительный счет №", bold: true, },
                    ` ${it.title}`
                ]
            },
            {
                style: 'client',
                text: [
                    "Пациент: ",
                    { text: `${it.fio} ${it?.birthday ? "(" + helper.date.toStr(it.birthday, "DD.MM.YYYY") + ")" : ""}`, bold: true, },
                ]
            },
            {
                style: 'doctor',
                text: [
                    "Врач: ",
                    { text: it.doctor, bold: true, },

                ]
            },
            {
                style: 'doctor',
                text: [
                    "Этап: ",
                    { text: it.treatmentTask?.title, bold: true },

                ]
            },
            {
                /*unbreakable: true,*/
                style: 'table',
                table: getRows(it, isDiscount)
            },
            {
                style: "itogoInvoice",
                text: ["Итого по счету: ", { text: helper.number.toSum(it.totalSum), bold: true }]
            },
        ];

        return page;
    };

    const formContent = () => {
        let arr = [];
        listInv.forEach((it, i) => {
            arr = [...arr, ...formPage(it, (i + 1 === listInv.length))];
        });
        return arr;
    };

    const getProperty = () => {
        const { clinic } = listInv[0];
        const { organisationName, address, license, phone, city } = clinic;
        const lic = license.split(' от ')[0];
        const add = city.name + " " + address;
        const ph = "Тел: " + helper.inputValidators.phone(phone);

        return { organisationName, lic, add, ph };
    };

    const property = getProperty();
    const balance = listInv[0].clientBalance?.balance + listInv[0].clientBalance?.bonus;

    const documentDefinition = {
        pageSize: 'A4',
        content: [
            /*{
                image: await getBase64ImageFromURL("/img/br_header-for-A4.png"),
                width: 515,
                rowSpan: 2,
                margin: [0, -20, 0, 0]
            },*/
            {
                style: 'header',
                table: {

                    widths: ['*', 150],
                    body: [
                        [
                            property.organisationName,
                            "Приложение"
                        ],
                        [
                            property.lic,
                            "к Договору об оказании"
                        ],
                        [
                            property.add,
                            "платных медицинских услуг"
                        ],
                        [
                            property.ph,
                            `№ ${listInv[0].profileNumber} от ${helper.date.toStr(listInv[0].dateRegistration, "DD.MM.YYYY")}`
                        ],
                    ],
                },
                layout: 'noBorders'
            },
            ...formContent(),
            {
                style: 'itogo',
                text: "Итого: "
            },
            {
                table: {
                    widths: [100, "*", 100, 60],
                    body: [
                        [
                            { text: "По всем счетам: " },
                            { text: helper.number.toSum(listInv.reduce((s, { totalSum }) => s + totalSum, 0)), bold: true },
                            "Сумма на авансе:",
                            { text: helper.number.toSum(balance), bold: true },
                        ],
                        [
                            "",
                            "",
                            { text: "Общий долг: " },
                            { text: helper.number.toSum(listInv[0].debt), bold: true },
                        ]

                    ],
                },
                layout: 'noBorders'
            },
            {
                unbreakable: true,
                style: 'itogoTable2',
                table: {
                    dontBreakRows: true,
                    widths: ['*'],
                    body: [
                        [
                            `После обследования в доступной для меня форме мне даны разъяснения о моем диагнозе, объеме, целях и методах оказания медицинской помощи, связанном с ними риске, 
возможных вариантах медицинского вмешательства, о его последствиях и осложнениях, а также о предполагаемых результатах оказания медицинской помощи`
                        ],
                        [
                            `Мне понятно, что в ходе лечения могут быть выявлены новые обстоятельства, 
способные повлиять на план и этапы лечения, а также вызвать необходимость дополнительного обследования, изменения сроков лечения, дополнительной оплаты.`,
                        ],
                        [
                            "У меня была возможность задать все интересующие вопросы.",
                        ],
                        [
                            "Даю добровольное информированное согласие на медицинское вмешательство.",
                        ],

                    ],
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                    },
                    hLineStyle: function (i, node) {
                        return { dash: { length: 3, space: 2 } };
                    },
                    vLineStyle: function (i, node) {
                        return { dash: { length: 3, space: 2 } };
                    },
                    paddingLeft: function (i, node) { return 5; },
                    paddingRight: function (i, node) { return 5; },
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; },
                }
            },
            {
                style: 'signTable',
                table: {

                    widths: ['*', 260],
                    body: [
                        [
                            "Врач________________________________",
                            "Пациент__________________________________",
                        ],
                        [
                            "",
                            { text: listInv[0].fio, bold: true },
                        ],
                        [
                            "",
                            "Законный представитель:________________",
                        ],

                    ],
                },
                layout: 'noBorders'
            },
        ],
        styles: {
            header: {
                fontSize: 9,
                lineHeight: 0.7,
                margin: [0, 10, 0, 20]
            },
            header2: {
                fontSize: 12,
                alignment: 'center',
                margin: [0, 0, 0, 15]
            },
            client: {
                margin: [0, 0, 0, 10]
            },
            itogoInvoice: {
                margin: [0, 15, 0, 15]
            },
            doctor: {
                margin: [0, 0, 0, 15]
            },
            table: {
                fontSize: 9,
            },
            itogo: {
                fontSize: 14,
                bold: true,
                margin: [0, 5, 0, 5]
            },
            itogoTable: {
            },
            itogoTable2: {
            },
            signTable: {
                margin: [0, 20, 0, 0]
            },
        },
        defaultStyle: {
            fontSize: 10,
        }
    };

    pdfMake.createPdf(documentDefinition).open();

};

export default Print;
